// extracted by mini-css-extract-plugin
export default {"root":"TeamsystemAppBar_root__sssvK","navbarWrapper":"TeamsystemAppBar_navbarWrapper__eX2Av","navbarWrapperLogo":"TeamsystemAppBar_navbarWrapperLogo__3J4ti"};